// Mounts the platform-provided user-create route at /admin/users/new.
//
// Default mount — platform field set (email + displayName), platform
// submit pipeline (POST /api/users → 201 → navigate to /admin/users/$id).
//
// Override pattern: if gfo wants to add a domain-specific field (e.g.
// `agentCode`), don't mount `userCreateRoute` here — write a custom
// component that calls `userCreateFormMeta(onSubmit)`, then
// `mergeFormMeta(meta, { fields: { ...meta.fields, agentCode: {…} } })`,
// then renders `<ResourceForm meta={extended} />` inside `<FormPage>`.

import { userCreateRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/users/new')({
  ...userCreateRoute,
  staticData: {
    breadcrumb: 'New user',
  },
})
